module.exports = __webpack_public_path__ + "static/media/OneSmartSheepBookCover.a1a57f6c.jpg";